"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = withBaseTheme;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _reactJss = require("react-jss");

var _jss = require("./jss");

var _base = _interopRequireDefault(require("./base"));

var generateId = (0, _jss.createGenerateId)();
var managers = {};
var globalJssContext = {
  generateId: generateId,
  managers: managers,
  jss: _jss.globalJss,
  registry: _jss.globalSheetsRegistry
};

var getBaseTheme = function getBaseTheme() {
  return _base.default;
};

function withBaseTheme(Component) {
  var WithThemeProvider = (0, _react.forwardRef)(function WithThemeProvider(props, ref) {
    var themeContext = (0, _react.useContext)(_jss.ThemeProviderContext);
    if (themeContext.jss) return _react.default.createElement(Component, (0, _extends2.default)({
      ref: ref
    }, props));
    return _react.default.createElement(_reactJss.JssContext.Provider, {
      value: globalJssContext
    }, _react.default.createElement(_jss.JssThemeProvider, {
      theme: getBaseTheme
    }, _react.default.createElement(Component, (0, _extends2.default)({
      ref: ref
    }, props))));
  });
  return WithThemeProvider;
}